import clsx from 'clsx'
import {FormikValues} from 'formik'
import {useCallback, useEffect, useRef} from 'react'
import Flatpickr from 'react-flatpickr'
import {nDaysAgo} from '../helperFunction/_helper'

type Props = {
  formik: FormikValues
  fieldName: string
  placeholder?: string
  container?: string
  dateformat?: string
  isCustom?: boolean
}

const FlatPickrDate = ({
  formik,
  fieldName,
  placeholder = 'Pick a Date',
  container,
  dateformat = 'Y-m-d',
  isCustom = false,
}: Props) => {
  const handleReady = (
    selectedDates: Date[],
    dateStr: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    instance: any
  ) => {
    const calendar = instance.calendarContainer

    // Modify inline styles
    if (calendar) {
      calendar.style.top = '40px'
      calendar.style.left = '0px'
      calendar.style.width = '100%'
      calendar.style.display = 'inline'
    }
  }

  const flatpickrRef = useRef<Flatpickr>(null)

  let minDate = isCustom ? new Date(nDaysAgo(90)).toLocaleDateString('en-CA') : null

  const destroyFlatpickr = useCallback(() => {
    try {
      if (flatpickrRef.current?.flatpickr?.destroy) {
        flatpickrRef.current.flatpickr.destroy()
      }
    } catch (error) {
      console.warn('Flatpickr destruction error', error)
    }
  }, [])

  // useEffect(() => {
  //   return () => destroyFlatpickr()
  // }, [destroyFlatpickr])

  return (
    <Flatpickr
      ref={flatpickrRef}
      onReady={handleReady}
      value={formik.values[fieldName]} // Correct dynamic field access
      onChange={([date]) => {
        // const formattedDate = date ? date.toISOString().split("T")[0] : "";
        const formattedDate = date ? date.toLocaleDateString('en-CA').split('T')[0] : ''
        formik.setFieldValue(fieldName, formattedDate)
        formik.setFieldValue('exportTimeRange', 'Custom')
        formik.setFieldValue('exportTimeRangeId', 12)
        // const customMinDate = isCustom ? new Date(nDaysAgo(90, formattedDate)) : null
        // minDate = customMinDate
      }}
      className='form-control form-control custom-input mb-3 mb-lg-0 w-100'
      options={{
        static: true,
        enableTime: false, // Disable time selection
        dateFormat: dateformat, // Only show date
        clickOpens: true, // Only open on click
        appendTo: (container && document.getElementById(container)) || undefined,
        minDate: minDate ?? undefined,
        maxDate: new Date(),
      }}
      placeholder={placeholder}
    />
  )
}

export default FlatPickrDate
